const campaignsStrings = {
  campaignsFilter: {
    searchBarPlaceholder: 'Campaign ID or Name',
  },

  campaignsList: {
    campaignsGridNoResultsFound: 'No results matching your search criteria',
    campaignsGridHeader: {
      campaignsNameGridHeader: 'Name',
      campaignsStatusGridHeader: 'Status',
      campaignsTypeGridHeader: 'Type',
      campaignsBillingGridHeader: 'Billing',
      campaignsZoneGridHeader: 'Zone',
      campaignsStartDateGridHeader: 'Start Date',
      campaignsEndDateGridHeader: 'End Date',
      campaignsLandingPageGridHeader: 'Landing Page',
      campaignsActionsGridHeader: 'Actions',
    },
    campaignsGridEditActionBtn: 'Edit',
    campaignsGridAddAdvertActionBtn: 'Add Advert',
    campaignsGridViewAdvertsActionBtn: 'View Adverts',
    campaignsGridActivateActionBtn: 'Activate',
    campaignsGridDeactivateActionBtn: 'Deactivate',
    actionPopupTitle(status) {
      return `Are you sure you want to mark this campaign as ${status} ?`;
    },
    actionPopupYesBtn: 'Yes',
    actionPopupNoBtn: 'No',
  },

  addCampaign: {
    formTitle: 'Campaign Details',
    formNameFieldLabel: 'Name',
    formTypeFieldLabel: 'Type',
    formTypeFieldPlaceholder: 'Select Type',
    formBillingFieldLabel: 'Billing',
    formBillingFieldPlaceholder: 'Select Billing',
    formZoneFieldLabel: 'Zone',
    formZoneFieldPlaceholder: 'Add Zone(s)',
    formStartDateFieldLabel: 'Start Date',
    formEndDateFieldLabel: 'End Date',
    formTargetFieldLabel: 'Target',
    formTargetFieldPlaceholder: 'Select Target',
    formTargetKeyFieldPlaceholder: 'Target Key',
    formTargetValueFieldPlaceholder: 'Target Value',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    formAddTargetBtnText: 'Add Target',
    formAddBtnText: 'Add',
    formEditBtnText: 'Edit',
  },
};

export default campaignsStrings;
